<template>
<ul class="nav nav-pills nav-stacked nav-bordered row">
  <router-link tag="li" role="presentation" :to="{ name: 'Homepage' }">
    <a href="">Strona główna</a>
  </router-link>
  <router-link tag="li" role="presentation" :to="recordsRoute">
    <a href="">Notowania</a>
  </router-link>
  <router-link tag="li" role="presentation" :to="{ name: 'Producers' }">
    <a href="">Kontrahenci</a>
  </router-link>
  <router-link tag="li" role="presentation" :to="{ name: 'Products' }">
    <a href="">Produkty</a>
  </router-link>
  <router-link tag="li" role="presentation" :to="{ name: 'Notices' }">
    <a href="">Ogłoszenia</a>
  </router-link>
  <router-link tag="li" role="presentation" :to="{ name: 'Regulations' }">
    <a href="">Regulamin</a>
  </router-link>
  <router-link tag="li" role="presentation" :to="{ name: 'PriceList' }">
    <a href="">Cennik</a>
  </router-link>
  <router-link tag="li" role="presentation" :to="{ name: 'Contact' }">
    <a href="">Kontakt</a>
  </router-link>
  <router-link tag="li" role="presentation" :to="{ name: 'Users' }">
    <a href="">Użytkownicy notowań</a>
  </router-link>
  <router-link tag="li" role="presentation" :to="{ name: 'Payments' }">
    <a href="">Płatności</a>
  </router-link>
</ul>
</template>
<script>
import moment from 'moment'

export default {
  data () {
    return {
      defaultDate: moment().format('YYYY-MM-DD')
    }
  },
  computed: {
    recordsRoute () {
      return {
        name: 'Records',
        params: {
          id: this.defaultDate
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Sidebar.vue?787ff74e